import React from 'react';

const pecelImages = [
  {
    src: '/images/IMG_8808.jpg',
    title: 'Authentic Pecel Madiun',
    description: 'A generous plate of fresh greens, tempeh, and peanut sauce served with crunchy crackers.'
  },
  {
    src: '/images/IMG_8811.jpg',
    title: 'Fresh Ingredients',
    description: 'Colorful boiled vegetables and herbs come alive under spicy peanut sauce.'
  },
  {
    src: '/images/IMG_8824.jpg',
    title: 'Warm Traditional Serving',
    description: 'Served with banana leaf and classic Javanese side dishes for full flavor.'
  },
  {
    src: '/images/IMG_8834.jpg',
    title: 'Rich, Nutty Sauce',
    description: 'The savory pecel dressing brings depth and warmth to every vegetable bite.'
  }
];

function PecelMadiun() {
  return (
    <section id="menu" className="py-16 md:py-24 bg-cream">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.3em] text-red-800 font-semibold mb-2">Culinary Spotlight</p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#5A2A1B]">Pecel Madiun</h2>
          <p className="mt-4 text-[#4D2A1F] max-w-2xl mx-auto">
            Discover the flavors of Madiun with this beloved Javanese dish: fresh vegetables, savory peanut sauce,
            traditional sambal, and crispy side bites crafted for every meal.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pecelImages.map((item, index) => (
            <div key={index} className="bg-white rounded-[2rem] overflow-hidden shadow-xl transition hover:-translate-y-1 hover:shadow-2xl">
              <img
                src={item.src}
                alt={item.title}
                className="h-64 w-full object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-red-800 mb-2">{item.title}</h3>
                <p className="text-[#5A2A1B]">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PecelMadiun;
